import { getQueryParam } from '../../../../utils/helpers/url'

export const getPlaceId = () => {
  const placeId = getQueryParam('placeId')
  const identifier = getQueryParam('identifier')

  if (!!placeId) return parseInt(placeId)
  if (!!identifier) return parseInt(Buffer.from(identifier, 'base64'))

  return undefined
}

export const getInvite = () => {
  return getQueryParam('invite')
}
